import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import styles from './index.module.scss';
import Button from 'components/Button';
import fieldSelection from 'components/Forms/Fields';
import Checkbox from 'components/Checkbox';
import TextArea from 'components/Forms/Fields/TextArea';
import TextInput from 'components/Forms/Fields/TextInput';
import { generalSection } from './option';
import RadioButtonsGroup from 'components/RadioButton';
import MultipleCheckBox from 'components/Forms/Fields/Checkbox';
import { TASK_EVIDENCE_TYPE } from 'utils/constants/task';
import Signature from '../Signature/signature';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';

const useStyles = makeStyles(theme => ({
  formContainerBackground: {
    background: theme.palette.background.default,
  },
}));
const getMultiSelectdata = data => {
  switch (data.type) {
    case TASK_EVIDENCE_TYPE.OPTION_MULTIPLE.id: {
      const filteredMultiSelectedData = data.contents.options
        .filter(f => f.selected)
        .map(m => m.title);
      return filteredMultiSelectedData || [];
    }
    case TASK_EVIDENCE_TYPE.OPTION_SINGLE.id: {
      const filteredSingleData = data.contents?.options.find(f => f.selected);
      return filteredSingleData?.title || '';
    }
    default:
      return null;
  }
};
export const EvidenceSubForm = ({ type, cancel, submit, data }) => {
  const classes = useStyles();
  const fields = generalSection();
  const [values, setValues] = useState(data);
  const [textOption, setTextOption] = useState({
    [TASK_EVIDENCE_TYPE.OPTION_SINGLE.id]: getMultiSelectdata(data),
    [TASK_EVIDENCE_TYPE.OPTION_MULTIPLE.id]: getMultiSelectdata(data),

    [TASK_EVIDENCE_TYPE.SIGNATURE.id]: null,
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const setFieldTouched = key => {
    setTouched({ ...touched, [key]: true });
  };

  const handleChange = event => {
    switch (type) {
      case 'CHECKBOX':
        return setValues({
          ...values,
          completed: !values?.completed,
        });
      case 'DESCRIPTION':
        return setValues({
          ...values,
          contents: event?.target?.value,
          completed: event?.target?.value !== '' && true,
        });
      case 'NUMERIC':
        return setValues({
          ...values,
          contents: event, // this only has the number string
          completed: event !== '' && true,
        });
      case TASK_EVIDENCE_TYPE.OPTION_SINGLE.id:
        setTextOption({ [TASK_EVIDENCE_TYPE.OPTION_SINGLE.id]: event.id });
        return setValues({
          ...values,
          contents: {
            options: values.contents.options.map(m => {
              if (event.id === m.title) {
                return { ...m, selected: event.id === m.title };
              }
              return { ...m, selected: false };
            }),
          },
          completed: true, // if any of the option is selected then it is completed
        });
      case TASK_EVIDENCE_TYPE.OPTION_MULTIPLE.id:
        setTextOption(prev => ({
          ...prev,
          [TASK_EVIDENCE_TYPE.OPTION_MULTIPLE.id]: event,
        }));
        return setValues({
          ...values,
          contents: {
            options: values.contents.options.map(m => {
              if (event && event.includes(m.title)) {
                return { ...m, selected: true };
              }
              return { ...m, selected: false };
            }),
          },
          completed: true, // if any of the option is selected then it is completed
        });
      case TASK_EVIDENCE_TYPE.SIGNATURE.id:
        setTextOption(prev => ({
          ...prev,
          [TASK_EVIDENCE_TYPE.SIGNATURE.id]: event,
        }));
        return setValues({
          ...values,
          contents: event,
          completed: event !== null,
        });
      default:
        return {};
    }
  };

  const submitEvidence = () => {
    let tempErrors = '';
    let tempTouched = false;
    if (
      values.type === TASK_EVIDENCE_TYPE.OPTION_SINGLE.id &&
      textOption[TASK_EVIDENCE_TYPE.OPTION_SINGLE.id] === ''
    ) {
      // check for empty values
      tempErrors = 'required_label';
      tempTouched = true;
      setTouched(tempTouched);
      setErrors(tempErrors);
      return;
    }
    if (
      values.type === TASK_EVIDENCE_TYPE.SIGNATURE.id &&
      !textOption[TASK_EVIDENCE_TYPE.SIGNATURE.id]
    ) {
      // check for empty values
      tempErrors = 'required_label';
      tempTouched = true;
      setTouched(tempTouched);
      setErrors(tempErrors);
      return;
    }
    if (
      values.type === TASK_EVIDENCE_TYPE.OPTION_MULTIPLE.id &&
      textOption[TASK_EVIDENCE_TYPE.OPTION_MULTIPLE.id].length === 0
    ) {
      // check for empty values
      tempErrors = 'required_label';
      tempTouched = true;
      setTouched(tempTouched);
      setErrors(tempErrors);
      return;
    }
    submit(values);
  };

  const setFieldValue = (key, value) => {
    setValues({ ...values, [key]: value });
  };

  const displayEvidenceType = (type, data) => {
    switch (type) {
      case 'CHECKBOX':
        return (
          <Checkbox
            title={'checkbox'}
            disabled={false}
            onChange={event => handleChange(event)}
            value={values?.completed}
          />
        );
      case 'DESCRIPTION':
        return (
          <TextArea
            title={'description'}
            label={'Description'}
            field={'TextArea'}
            onChange={event => handleChange(event)}
            placeholder="Enter description here."
            maxLength={250}
            value={values?.contents && values.contents}
          />
        );
      case 'NUMERIC':
        return (
          <TextInput
            title={'numeric'}
            placeholder={'Enter number here.'}
            type={'number'}
            label={'Number'}
            value={values?.contents && values.contents}
            onChange={event => handleChange(event)}
          />
        );
      case TASK_EVIDENCE_TYPE.OPTION_SINGLE.id:
        return (
          <RadioButtonsGroup
            onChange={event => handleChange(event)}
            label={'Single Select Options'}
            options={values.contents?.options.map(m => ({
              ...m,
              id: m.title,
              value: m.title,
            }))}
            value={{ value: textOption[TASK_EVIDENCE_TYPE.OPTION_SINGLE.id] }}
            item={{ field: 'textOptions', valueType: 'object' }}
            required={true}
          />
        );
      case TASK_EVIDENCE_TYPE.OPTION_MULTIPLE.id:
        return (
          <MultipleCheckBox
            onChange={event => handleChange(event)}
            label={'Multiple Select Options'}
            options={values.contents.options.map(m => ({
              ...m,
              id: m.title,
              name: m.title,
            }))}
            value={textOption[TASK_EVIDENCE_TYPE.OPTION_MULTIPLE.id]}
            field={'textOptions'}
            required={true}
          />
        );
      case TASK_EVIDENCE_TYPE.SIGNATURE.id:
        return (
          <Signature
            onChange={event => handleChange(event)}
            label={'Signature'}
            required={true}
            error={errors}
            base64url={data?.contents}
          />
        );
      default:
        return null;
    }
  };

  const props = {
    values,
    errors,
    touched,
    setFieldTouched,
    handleChange,
    setFieldValue,
  };

  return (
    <div className={cn(styles.formContainer, classes.formContainerBackground)}>
      <form className={styles.form}>
        <div className={styles.fixedLeft}>
          {displayEvidenceType(type, data)}
        </div>
        <div className={styles.inputs}>
          {fields.map((field, index) =>
            fieldSelection({
              item: field,
              key: index,
              id: index,
              props: props,
            }),
          )}
          <Button
            type="button"
            text="Cancel"
            onClick={cancel}
            size="l"
            color="secondary"
            outline={true}
          />
          <Button
            type="button"
            onClick={submitEvidence}
            text="Submit"
            size="l"
            color="primary"
          />
        </div>
      </form>
    </div>
  );
};

EvidenceSubForm.propTypes = {
  submit: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  formProps: PropTypes.object,
  data: PropTypes.object,
  type: PropTypes.string,
};
